const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBonusbuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5681E"
    },
    d: "M211.493,0c-14.067,0-23.957,13.841-19.4,27.15l28.493,83.201l35.413,20.898V0H211.493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#983300"
    },
    d: "M300.507,0H256v131.249l0,0l35.413-20.898l28.493-83.201C324.465,13.841,314.574,0,300.507,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9933"
    },
    d: "M53.628,311.362v91.894C53.628,463.314,102.315,512,162.373,512H256V107.262 C144.659,107.268,53.628,199.976,53.628,311.362z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5681E"
    },
    d: "M256.37,107.258c-0.124,0-0.247,0.004-0.37,0.004V512h93.627 c60.058,0,108.745-48.686,108.745-108.744v-93.627C458.372,197.986,367.967,107.457,256.37,107.258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#53B400"
    },
    d: "M359.213,288.968c0-16.437-13.325-29.762-29.762-29.762c-10.503,0-20.52,2.637-29.727,6.7l0,0 l-60.827,43.725l60.827,43.725c9.208,4.063,19.224,6.7,29.727,6.7c16.437,0,29.762-13.325,29.762-29.762 c0-8.028-3.184-15.309-8.352-20.662C356.029,304.275,359.213,296.996,359.213,288.968z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CD800"
    },
    d: "M212.275,265.905c-9.208-4.063-19.224-6.7-29.727-6.7c-16.437,0-29.762,13.325-29.762,29.762 c0,8.028,3.184,15.309,8.352,20.662c-5.167,5.353-8.352,12.634-8.352,20.662c0,16.437,13.325,29.762,29.762,29.762 c10.503,0,20.519-2.637,29.727-6.7l0,0l30.47-12.94L256,309.628l-17.103-35.488L212.275,265.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CD800"
    },
    d: "M299.725,265.905c4.063-9.208,6.7-19.224,6.7-29.726c0-16.437-13.325-29.762-29.762-29.762 c-8.028,0-15.309,3.184-20.662,8.352l-17.103,43.255L256,309.628L299.725,265.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CD800"
    },
    d: "M256,309.628l-17.103,51.606L256,404.49c5.353,5.167,12.634,8.352,20.662,8.352 c16.437,0,29.762-13.325,29.762-29.762c0-10.503-2.637-20.519-6.7-29.727L256,309.628z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93F340"
    },
    d: "M256,214.767L256,214.767c-5.353-5.167-12.634-8.352-20.662-8.352 c-16.437,0-29.762,13.325-29.762,29.762c0,10.503,2.637,20.519,6.7,29.727L256,309.628l0,0V214.767z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#93F340"
    },
    d: "M256,309.628l-43.725,43.725c-4.063,9.208-6.7,19.224-6.7,29.726 c0,16.437,13.325,29.762,29.762,29.762c8.028,0,15.309-3.184,20.662-8.352l0,0L256,309.628L256,309.628z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9933"
    },
    d: "M349.627,473.776v-31.347c21.6,0,39.173-17.573,39.173-39.173v-40.539h31.347v40.539 C420.148,442.141,388.512,473.776,349.627,473.776z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#541D00"
    },
    d: "M256,74.187c15.568,0,31.135,1.366,46.397,4.091l10.257-29.95 c-18.593-3.641-37.621-5.485-56.654-5.485L235.101,60.56L256,74.187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#702600"
    },
    d: "M256,74.187V42.843c-19.033,0-38.06,1.843-56.654,5.485l10.257,29.95 C224.864,75.552,240.432,74.187,256,74.187z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusbuy);
export default __webpack_public_path__ + "static/media/bonus buy.16870c30c54605a73e471b0d294bc4ef.svg";
export { ForwardRef as ReactComponent };